import classNames from 'classnames';
import React from 'react';
import { HearthBeatLoader } from '../loaders';
import { iconButtonClasses, IconButtonSC } from './icon-button.styled';
import { IconButtonProps } from './icon-button.types';
import { iconSize, loaderSize, loaderStyle, useButtonStyle } from './icon-button.utils';

const IconButton = (props: IconButtonProps, ref?: React.Ref<HTMLButtonElement>) => {
  const {
    label,
    variant = 'primary',
    Icon,
    loading,
    disabled = false,
    size = 'large',
    style,
    type = 'button',
    className,
    shape = 'squared',
    surface = 'on-light',
    ...rest
  } = props;

  const styleConfig = useButtonStyle({ variant, size, shape, surface });

  return (
    <IconButtonSC
      {...rest}
      ref={ref}
      $variant={variant}
      $size={size}
      $shape={shape}
      $color={styleConfig.color}
      $backgroundColor={styleConfig.backgroundColor}
      $borderColor={styleConfig.borderColor}
      $surface={surface}
      style={style}
      type={type}
      disabled={disabled}
      className={classNames(
        iconButtonClasses.wrapper,
        `${iconButtonClasses.wrapper}-${shape}`,
        `${iconButtonClasses.wrapper}-${variant}`,
        `${iconButtonClasses.wrapper}-${size}`,
        `${iconButtonClasses.wrapper}-${surface}`,
        className,
        { [iconButtonClasses.loading]: loading },
      )}
    >
      <div className={iconButtonClasses.inner}>
        <Icon
          width={iconSize[size]}
          height={iconSize[size]}
          color={styleConfig.iconColor}
          className={iconButtonClasses.icon}
        />
        {loading ? (
          <div className={iconButtonClasses.loader}>
            <HearthBeatLoader loading size={loaderSize[size]} variant={loaderStyle[variant]} />
          </div>
        ) : null}
      </div>
      {label ? <div className={iconButtonClasses.label}>{label}</div> : null}
    </IconButtonSC>
  );
};

export default React.forwardRef(IconButton);
